export enum AddressStatus {
    Visited = 0,
    UnVisited = 1,
    NDZ = 2,
    Sticker = 3,
    OtherPk = 4,
    FalseAddressPoint = 5
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/address-status.ts